module.exports = __webpack_public_path__ + "img/NYC - Invention Bingo.577ca0b6.jpeg";